exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.view-form .form-control:disabled, .view-form .form-control[readonly], .view-form .custom-select {\n  background-color: #ffffff !important;\n  border:none;\n  background: none !important;\n}\n.view-form .input-group-append {\n  display: none;\n}\n", ""]);

// exports
